import { parse } from 'date-fns'

import BaseService from '@/services/BaseService'
import { WbEnvironments } from '@interco/inter-webview-bridge'
import { BaseBridge } from '@/services/BaseBridge'

import Colors from './Colors'
import FontFamily from './FontFamily'
import GoogleTags from './GoogleTags'

export const SALDO_MINIMO = 100
export const MAX_FGTS_BALANCE = 2500 // 500 per year × 5 years maximum
export const DEBOUNCE_TIME_SIMULACAO = 1000

/** Caps manual FGTS balance sent to APIs to the maximum allowed by backend rules. */
export const capSaldoFgtsForApi = (saldoFgts: number): number =>
  Math.min(saldoFgts, MAX_FGTS_BALANCE)

export { Colors, FontFamily, GoogleTags }

/**
 * Returns API business error code only (`erro.mensagem` paths). Does not use raw `e.message`
 * (network/Axios text) so callers can distinguish UNMAPPED vs transport errors via validarErro + telemetry.
 */
export const getMensagemErro = (e: ErrorResponseApi): string | undefined => {
  const candidates = [
    e?.data?.erro?.mensagem,
    e?.response?.data?.erro?.mensagem,
    e?.message?.erro?.mensagem,
  ]
  for (const m of candidates) {
    if (typeof m === 'string' && m.trim() !== '') {
      return m
    }
  }
  return undefined
}

export const parseDate = (date: string, pattern = 'dd/MM/yyyy') => parse(date, pattern, new Date())

export const redirectFGTS = () => {
  if (BaseBridge.isBrowser()) {
    window.open(
      'https://play.google.com/store/apps/details?id=br.gov.caixa.fgts.trabalhador&hl=pt_BR&gl=US',
      '_blank',
      'noopener',
    )
  } else {
    BaseBridge.openDeepLink(
      BaseService.getEnvironment() === WbEnvironments.ANDROID
        ? 'https://play.google.com/store/apps/details?id=br.gov.caixa.fgts.trabalhador&hl=pt_BR&gl=US'
        : 'https://apps.apple.com/br/app/fgts/id1038441027',
    )
  }
}
